
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Mumbaitokohlapur() {



  const cardData =
  {
    keyword: ' Mumbai To Kolhapur Cab',
    heading: 'SHREE Tours & Travels: Mumbai To Kolhapur Cab',
    headingDescription: 'SHREE Tours & Travels offers a dependable Mumbai to Kolhapur Cab service, ensuring a smooth and comfortable journey. Whether youre traveling for business, pilgrimage to Mahalaxmi Temple, or leisure, our well-maintained Cabs and professional drivers provide a hassle-free experience. With on-time pickups, flexible booking options and affordable fares, we guarantee a safe and convenient ride. Choose SHREE Tours & Travels for a stress-free Mumbai to Kolhapur travel experience.',

    top: 'Top Places to Visit in Kolhapur with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Mahalaxmi Temple",
        "description": "The Mahalaxmi Temple, also known as the Ambabai Temple, is one of the most revered religious sites in Kolhapur. Dedicated to Goddess Mahalaxmi, this ancient temple is an architectural marvel, built in the 7th century during the Chalukya reign. It is believed that worshipping here brings prosperity and success. The temple features beautifully carved stone walls, intricate sculptures and a grand sanctum housing the deity. Devotees flock here throughout the year, with special celebrations during Navratri drawing thousands of visitors. Nearby, the temple complex offers shops selling religious souvenirs and delicious local sweets."
    },
    {
        "title": "Panhala Fort",
        "description": "Panhala Fort, the largest fort in the Deccan region, is a historical treasure associated with Chhatrapati Shivaji Maharaj. Situated at an altitude of 3,000 feet, the fort offers panoramic views of the Sahyadri mountains. Built in the 12th century, it played a significant role in Maratha history, including the famous Battle of Pavan Khind. Visitors can explore key attractions within the fort, such as the Andhar Bavadi (Hidden Well), Sajja Kothi (Punishment Chamber) and the Teen Darwaza (Three Gates). The fort is also a great spot for trekking and photography, especially during the monsoon when the lush greenery enhances its beauty."
    },
    {
        "title": "Rankala Lake",
        "description": "Rankala Lake, a serene man-made lake in the heart of Kolhapur, is a favorite spot for locals and tourists alike. Surrounded by lush gardens, walking paths and food stalls, the lake is perfect for an evening stroll, boating, or simply enjoying the peaceful ambiance. The historic Shalini Palace stands nearby, adding to the charm of the location. Visitors can savor delicious street food like Bhel Puri and Kolhapuri Misal Pav from the numerous stalls around the lake. The best time to visit is during sunset, when the sky reflects beautifully on the tranquil waters."
    },
    {
        "title": "Jyotiba Temple",
        "description": "Perched on a hill about 17 km from Kolhapur, the Jyotiba Temple is a sacred site dedicated to Lord Jyotiba, an incarnation of Lord Shiva. The temple, painted in a distinct pink color, stands out against the green surroundings. Thousands of devotees visit every year, particularly during the grand Chaitra Purnima festival, when the entire temple premises are covered in pink gulal (colored powder). The panoramic view from the hilltop is breathtaking, making it a must-visit for both spiritual seekers and nature lovers."
    },
    {
        "title": "New Palace Museum",
        "description": "The New Palace, a stunning Indo-Saracenic architectural masterpiece, is home to the Chhatrapati Shahu Museum. Built in the late 19th century, the palace showcases artifacts, paintings, weapons and memorabilia from the Kolhapur royal family. Visitors can explore the grand Darbar Hall, adorned with stained-glass windows, antique chandeliers and a display of Maratha history. The museum also houses a unique collection of hunting trophies, royal costumes and an impressive ivory throne. The lush palace gardens provide a perfect backdrop for photography and a relaxing stroll."
    },
    {
        "title": "Chinmaya Ganadhish",
        "description": "Chinmaya Ganadhish is a beautifully designed temple dedicated to Lord Ganesha, known for its tranquil surroundings and spiritual ambiance. The temple is a center for meditation and self-reflection, attracting visitors looking for inner peace. The lush gardens surrounding the temple create a serene environment, perfect for relaxation. Devotees can also participate in yoga sessions and spiritual discourses held at the temple complex."
    },
    {
        "title": "Shalini Palace",
        "description": "Overlooking Rankala Lake, Shalini Palace is an elegant structure built in the 1930s as a royal residence. The palace, constructed from black stone and Italian marble, features intricate woodwork and beautiful stained-glass windows. Though it has been converted into a heritage hotel, visitors can admire its grand architecture and serene setting. The palace, illuminated at night, provides a mesmerizing view of the lake, making it a great spot for photography."
    },
    {
        "title": "Khasbag Wrestling Stadium",
        "description": "Kolhapur is famous for its wrestling culture and Khasbag Wrestling Stadium is the largest traditional Kushti (wrestling) arena in India. This stadium, with its mud wrestling pits, hosts exciting wrestling matches that showcase the raw power and skill of local wrestlers. Visitors can witness live bouts and learn about the deep-rooted wrestling traditions of Kolhapur. The stadium is a significant place for those interested in traditional Indian sports and culture."
    },
    {
        "title": "Dajipur Wildlife Sanctuary",
        "description": "Located on the outskirts of Kolhapur, Dajipur Wildlife Sanctuary is a paradise for wildlife enthusiasts. The sanctuary is home to the majestic Indian bison (Gaur), along with deer, wild boars and leopards. Bird watchers can spot various species of rare and migratory birds. The lush greenery, waterfalls and trekking trails make it a perfect destination for adventure lovers. The best time to visit is during the monsoon and winter months when the forest is at its most vibrant."
    },
    {
        "title": "Kolhapur Local Market",
        "description": "A visit to Kolhapur is incomplete without exploring its bustling local markets. Famous for handcrafted Kolhapuri chappals, intricate jewelry and rich spices, the markets offer a unique shopping experience. The Shivaji Market and Laxmipuri Market are must-visits for those looking to buy authentic leather footwear and traditional Maharashtrian attire. Food lovers can also indulge in the city’s famous spicy Kolhapuri cuisine, including Tambda Rassa and Pandhra Rassa, available at local eateries."
    }
],  
    
            
"services": [
    {
      "name": "Mumbai to Kolhapur Taxi",
      "description": "Book a Cab from Mumbai to Kolhapur with SHREE Tours & Travels for a comfortable and hassle-free journey. Enjoy a smooth ride with experienced drivers and well-maintained vehicles."
    },
    {
      "name": "Mumbai to Kolhapur Cab Service",
      "description": "Looking for a reliable Cab service from Mumbai to Kolhapur? Our service offers one-way and round-trip options, ensuring a stress-free and comfortable ride."
    },
    {
      "name": "Mumbai to Kolhapur One-Way Taxi",
      "description": "Need a one-way taxi from Mumbai to Kolhapur? Our affordable and convenient one-way taxi service ensures a seamless journey without any hidden charges."
    },
    {
      "name": "Mumbai to Kolhapur Round Trip Cab",
      "description": "Planning a round-trip to Kolhapur from Mumbai? Book a round-trip Cab with us for a flexible travel experience, ensuring a comfortable ride both ways."
    },
    {
      "name": "Affordable Mumbai to Kolhapur Cab",
      "description": "Get affordable taxi services for your Mumbai to Kolhapur trip. Enjoy a reliable and smooth journey at competitive rates, without compromising on comfort."
    },
    {
      "name": "Private Taxi for Kolhapur from Mumbai",
      "description": "Book a private taxi for a personalized travel experience from Mumbai to Kolhapur. Travel in comfort and privacy with professional drivers at your service."
    },
    {
      "name": "Kolhapur Tour from Mumbai by Cab",
      "description": "Explore Kolhapur with our tour service from Mumbai. Our professional drivers and comfortable vehicles ensure an enjoyable and hassle-free trip with sightseeing options."
    },
    {
      "name": "Kolhapur Cab Hire",
      "description": "Hire a reliable Cab for your journey from Mumbai to Kolhapur. Choose from a variety of vehicles, ranging from budget-friendly to luxury options for your comfort."
    },
    {
      "name": "Group Travel from Mumbai to Kolhapur",
      "description": "Traveling with a group? Book our spacious Cabs for a comfortable and smooth group journey from Mumbai to Kolhapur, ensuring everyone travels together."
    },
    {
      "name": "Book Mumbai to Kolhapur Car",
      "description": "Rent a car for your Mumbai to Kolhapur trip with ease. Choose from sedans, SUVs, or tempo travelers, depending on your preference and group size."
    },
    {
      "name": "Kolhapur Cab Booking from Mumbai",
      "description": "Easily book a Cab from Mumbai to Kolhapur with our reliable online booking service. Enjoy on-time pickups and professional service at affordable rates."
    },
    {
      "name": "Kolhapur Trip by Cab",
      "description": "Plan your trip to Kolhapur with our convenient Cab service. Our experienced drivers ensure a comfortable and smooth journey, offering timely pickups and drop-offs."
    },
    {
      "name": "Kolhapur Road Trip from Mumbai",
      "description": "Planning a road trip from Mumbai to Kolhapur? Our Cab service offers comfortable vehicles and experienced drivers to make your scenic road trip enjoyable."
    },
    {
      "name": "Luxury Taxi for Kolhapur from Mumbai",
      "description": "Travel in luxury with our premium taxi service from Mumbai to Kolhapur. Choose from high-end vehicles like Innova Crysta or Mercedes for a lavish experience."
    }
  ],

  "tableData": [
    ["- Mumbai to Kolhapur Taxi", "- Mumbai to Kolhapur Cab Service"],
    ["- Mumbai to Kolhapur One-Way Taxi", "- Mumbai to Kolhapur Round Trip Cab"],
    ["- Affordable Mumbai to Kolhapur Cab", "- Private Taxi for Kolhapur from Mumbai"],
    ["- Kolhapur Tour from Mumbai by Cab", "- Kolhapur Cab Hire"],
    ["- Group Travel from Mumbai to Kolhapur", "- Book Mumbai to Kolhapur Car"],
    ["- Kolhapur Cab Booking from Mumbai", "- Kolhapur Trip by Cab"],
    ["- Kolhapur Road Trip from Mumbai", "- Luxury Taxi for Kolhapur from Mumbai"]
  ],


  
  whychoose: [
    {
      "WhyChooseheading": "Comfortable and Convenient Journey",
      "WhyChoosedescription": "Our Mumbai to Kolhapur Cab service ensures a comfortable and convenient ride with spacious seating, air-conditioning and smooth driving. Whether you're traveling for business or leisure, our well-maintained vehicles provide a pleasant journey, allowing you to relax and enjoy the trip."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our experienced drivers are familiar with the best routes from Mumbai to Kolhapur, ensuring a safe, smooth and timely journey. With their local expertise and focus on customer satisfaction, our drivers make sure your ride is as pleasant as possible."
    },
    {
      "WhyChooseheading": "Affordable Pricing",
      "WhyChoosedescription": "We offer competitive and transparent pricing for your Mumbai to Kolhapur Cab ride. No hidden charges and budget-friendly options are available for one-way or round-trip bookings. We provide the best value for money while ensuring excellent service quality."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "All our vehicles undergo regular maintenance and are equipped to provide a safe and comfortable ride. We take great care to ensure that our fleet is clean, reliable and mechanically sound, so you can travel with peace of mind throughout your journey."
    },
    {
      "WhyChooseheading": "Easy and Quick Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Kolhapur Cab with SHREE Tours & Travels is simple and hassle-free. You can easily book online through our user-friendly platform, or you can contact our customer service team for personalized assistance. We make booking fast and convenient."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for your Mumbai to Kolhapur Cab needs. Whether you need an early morning ride or a late-night transfer, we’re ready to accommodate your schedule, ensuring you can travel anytime it suits you."
    },
    {
      "WhyChooseheading": "Local Insights and Recommendations",
      "WhyChoosedescription": "Our drivers are not only skilled in driving but also knowledgeable about the local culture, attractions and routes between Mumbai and Kolhapur. They can offer recommendations for scenic spots or dining options along the way, adding value to your travel experience."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, customer satisfaction is our priority. We are committed to providing reliable, safe and timely service, ensuring that your Mumbai to Kolhapur journey is smooth, enjoyable and memorable. We guarantee that you will be pleased with your travel experience."
    }
  ]
  
  
  
  
  
  
  
  
  
  
  



        
  }

  const faqData = [
    {
        question: "How can I book a Cab from Mumbai to Kolhapur?",
        answer: "You can easily book your Mumbai to Kolhapur Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Mumbai to Kolhapur route?",
        answer: "We offer a variety of vehicles for the Mumbai to Kolhapur journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Mumbai to Kolhapur inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Mumbai to Kolhapur?",
        answer: "Yes, we offer one-way rental options for your Mumbai to Kolhapur trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Mumbai to Kolhapur trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Mumbai to Kolhapur Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Mumbai to Kolhapur Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Mumbai to Kolhapur trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Mumbai to Kolhapur?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Mumbai to Kolhapur?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The Mumbai to Kolhapur trip was fantastic! The driver was punctual and the vehicle was very comfortable throughout the journey.',
        name: 'Mr. Harish Jadhav',
    },
    {
        text: 'I had a great experience with SHREE Tours & Travels. The trip from Mumbai to Kolhapur was smooth and the driver was very helpful and friendly.',
        name: 'Miss. Meenal Joshi',
    }
];











  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a comfortable and reliable Mumbai to Kolhapur Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/mumbai-to-kolhapur-cab.jpg",
    "https://shreetoursandtravels.in/img/kolhapur-tour-cab.jpg"
  ],
  "priceRange": "₹3000 - ₹6000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/mumbai-to-kolhapur-cab-service",
    "priceCurrency": "INR",
    "price": 3500,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.6,
    "reviewCount": 1300
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Vikas Kulkarni"
      },
      "datePublished": "2024-09-10",
      "reviewBody": "The ride from Mumbai to Kolhapur was smooth and comfortable. The driver was very professional. Highly recommend SHREE Tours & Travels!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Meera Joshi"
      },
      "datePublished": "2024-09-25",
      "reviewBody": "We had a wonderful trip from Mumbai to Kolhapur. The car was well-maintained and the journey was enjoyable. Will book again!"
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Mumbai to Kolhapur Cab Service",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 19.0760,  // Mumbai latitude
      "longitude": 72.8777  // Mumbai longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/mumbai-to-kolhapur-cab-service"
  },
  "keywords": "Mumbai to Kolhapur Taxi, Mumbai to Kolhapur Cab Service, Mumbai to Kolhapur One-Way Taxi, Mumbai to Kolhapur Round Trip Cab, Affordable Mumbai to Kolhapur Cab, Private Taxi for Kolhapur from Mumbai, Kolhapur Tour from Mumbai by Cab, Kolhapur Cab Hire, Group Travel from Mumbai to Kolhapur, Book Mumbai to Kolhapur Car, Kolhapur Cab Booking from Mumbai, Kolhapur Trip by Cab, Kolhapur Road Trip from Mumbai, Luxury Taxi for Kolhapur from Mumbai"
};




  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Mumbai to Kolhapur Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Mumbai to Kolhapur Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Mumbai to Kolhapur Taxi, Mumbai to Kolhapur Cab Service, Mumbai to Kolhapur One-Way Taxi, Mumbai to Kolhapur Round Trip Cab, Affordable Mumbai to Kolhapur Cab, Private Taxi for Kolhapur from Mumbai, Kolhapur Tour from Mumbai by Cab, Kolhapur Cab Hire, Group Travel from Mumbai to Kolhapur, Book Mumbai to Kolhapur Car, Kolhapur Cab Booking from Mumbai, Kolhapur Trip by Cab, Kolhapur Road Trip from Mumbai, Luxury Taxi for Kolhapur from Mumbai" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/12.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Mumbaitokohlapur;